import $ from "jquery";
import Backbone from "backbone";


    var _classes = {
        trigger: {
            on: "PubliAccordion-trigger--on",
            off: "PubliAccordion-trigger--off"
        },
        target: {
            on: "PubliAccordion-target--on",
            off: "PubliAccordion-target--off"
        }
    };

    export default Backbone.View.extend({

        // initialize
        initialize: function () {
            var $items = this.$(".js-PubliAccordion-item"),
                $triggers = $items.find(".js-PubliAccordion-trigger"),
                $targets = $items.find(".js-PubliAccordion-target"),
                classNames = {
                    items: [],
                    targets: [],
                    triggers: []
                },
                len,
                i = 0;

            this.nbItems = $items.length;
            len = $items.length;
            this.$items = $items;
            this.$triggers = $triggers;
            this.$targets = $targets;


            for (i = 0; i < len; i += 1) {
                classNames.items[i] = $items.eq(i).attr("class");
                classNames.targets[i] = $targets.eq(i).attr("class");
                classNames.triggers[i] = $triggers.eq(i).attr("class");
            }

            this.classNames = classNames;
            this.initRender();
        },

        // events
        events: {
            "click .js-PubliAccordion-trigger": "getIndex"
        },

        // getIndex
        getIndex: function (e) {
            var $this = $(e.target),
                index = this.$triggers.index($this);

            this.render(index);
        },

        // initRender
        initRender: function () {
            this.$targets
                .removeClass(_classes.target.on)
                .addClass(_classes.target.off);
            this.$triggers
                .removeClass(_classes.trigger.on)
                .addClass(_classes.trigger.off)
                .data("accordion_itemState", "OFF")
            this.$items
                    .removeClass(_classes.target.on)
                    .addClass(_classes.target.off)
        },

        // render
        render: function (index) {
            var $target = this.$targets.eq(index),
                $trigger = this.$triggers.eq(index),
                $item = this.$items.eq(index),
                thisIsClosed = (this.$triggers.eq(index).data("accordion_itemState") === "OFF" ? true : false);

            this.initRender();

            if (thisIsClosed) {
                $trigger
                    .removeClass(_classes.trigger.off)
                    .addClass(_classes.trigger.on)
                    .data("accordion_itemState", "ON");
                $target
                    .removeClass(_classes.target.off)
                    .addClass(_classes.target.on);
                $item
                    .removeClass(_classes.target.off)
                    .addClass(_classes.target.on);
            } else {
                $trigger.data("accordion_itemState", "OFF");
            }
        }

    });
